import { MessageSquare, FileText, Paperclip } from 'lucide-react';

export type ProjectTab = 'conversations' | 'instructions' | 'files';

interface ProjectTabsProps {
  activeTab: ProjectTab;
  onTabChange: (tab: ProjectTab) => void;
  conversationsCount?: number;
  filesCount?: number;
}

/**
 * ProjectTabs - Abas de navegação dentro do projeto
 */
export const ProjectTabs = ({
  activeTab,
  onTabChange,
  conversationsCount = 0,
  filesCount = 0
}: ProjectTabsProps) => {
  const tabs = [
    {
      id: 'conversations' as ProjectTab,
      label: 'Conversas',
      icon: MessageSquare,
      count: conversationsCount
    },
    {
      id: 'instructions' as ProjectTab,
      label: 'Instruções Customizadas',
      icon: FileText,
      count: undefined
    },
    {
      id: 'files' as ProjectTab,
      label: 'Arquivos',
      icon: Paperclip,
      count: filesCount
    }
  ];

  return (
    <div className="px-8">
      <nav className="flex gap-8 border-b border-[#333333] w-fit">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;

          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`
                flex items-center gap-2 py-4 border-b-2 transition-colors -mb-px
                ${isActive
                  ? 'border-[#F4CC04] text-[#F4CC04]'
                  : 'border-transparent text-[#666666] hover:text-white'
                }
              `}
            >
              <Icon className="w-4 h-4" />
              <span className="text-sm font-medium">{tab.label}</span>
              {tab.count !== undefined && tab.count > 0 && (
                <span className={`
                  text-xs px-1.5 py-0.5 rounded-full
                  ${isActive ? 'bg-[#F4CC04]/20 text-[#F4CC04]' : 'bg-[#333333] text-[#666666]'}
                `}>
                  {tab.count}
                </span>
              )}
            </button>
          );
        })}
      </nav>
    </div>
  );
};
